/**
 * Created by Anthony on 30/05/2018.
 */
import {Network} from './network.model';

export class AgentNetworkConfig {
  get id(): number {
    return this._id;
  }

  get network(): Network {
    return this._network;
  }

  get defaultAgentCommission(): number {
    return this._defaultAgentCommission;
  }

  get systemCommission(): number {
    return this._systemCommission;
  }

  get swiftaCommission(): number {
    return this._swiftaCommission;
  }

  get userId(): number {
    return this._userId;
  }

  get hasPersonalCommission(): number {
    return this._hasPersonalCommission;
  }

  get agentPersonalCommission(): number {
    return this._agentPersonalCommission;
  }

  get agentCommission(): number {
    return this._hasPersonalCommission ? this.agentPersonalCommission : this.defaultAgentCommission;
  }

  private _id:               number;
  private _network:          Network;
  private _defaultAgentCommission : number;
  private _systemCommission: number;
  private _swiftaCommission:  number;
  private _userId: number;
  private _hasPersonalCommission:  number;
  private _agentPersonalCommission:  number;

  constructor( obj: any) {
    this._id = obj.id;
    this._network = obj.network;
    this._defaultAgentCommission = obj.defaultAgentCommission;
    this._systemCommission = obj.systemCommission;
    this._swiftaCommission = obj.swiftaCommission;
    this._userId = obj.userId;
    this._hasPersonalCommission = obj.hasPersonalCommission;
    this._agentPersonalCommission = obj.agentPersonalCommission;
  }
}




// WEBPACK FOOTER //
// ./src/app/util/models/network/agent-network-config.model.ts